<template>
    <div>
        <v-alert v-if="alert.message" :type="alert.type" v-html="alert.message"></v-alert>
        <v-form v-model="valid">
        <v-autocomplete :items="companies" v-model="company_ids"
            :label="trans('playlist-gateways.fields.company_ids')"            
            :rules="[rules.requiredMultiple]"
            :return-object="false"
            outlined
            multiple
            chips
            deletable-chips
        ></v-autocomplete>
        <v-card>
            <v-card-text>
                <div>
                    <input type="file" ref="fileInput" style="display: none" @change="handleFileSelect" />
                    <div ref="dropArea" class="drop-area" @dragover.prevent="preventDefaults" @drop="handleDrop"
                        @dragenter="highlight" @dragleave="highlight">
                        <span>Trascina qui i file o <v-btn small color="primary"
                                @click="$refs.fileInput.click()">Seleziona
                                File</v-btn></span>
                    </div>
                    <div class="mt-5" v-if="files.length > 0">
                        <v-list>
                            <v-list-item v-for="(file, index) in files" :key="index">
                                <v-list-item-content>
                                    <v-list-item-title>{{ (index + 1) + '. ' }} <b>{{ file.name
                                    }}</b></v-list-item-title>
                                    <v-list-item-subtitle>{{ formatFileSize(file.size) }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn icon small color="error" @click="removeFile(index)">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </div>
                </div>
            </v-card-text>
            <v-card-actions v-if="files.length > 0">
                <v-spacer></v-spacer>
                <v-btn color="success" @click="uploadFiles" :disabled="isUploading || !valid">
                    <v-icon left>upload</v-icon>
                    Carica
                </v-btn>
            </v-card-actions>
        </v-card>
        </v-form>
    </div>
</template>

<script>
import axios from 'axios';
import { useAttrs } from 'vue';

export default {
    props: {
        companies: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            valid: false,
            company_ids: [],
            files: [],
            isUploading: false,
            alert: {
                type: null,
                message: null
            },
            rules: {
                required: value => !!value || 'Campo richiesto!',
                requiredMultiple: value => value.length > 0 || 'Campo richiesto!',
            },
        };
    },
    methods: {
        handleDrop(event) {
            this.preventDefaults(event);
            this.highlight({
                type: 'dragleave'
            });
            this.files = [...this.files, ...Array.from(event.dataTransfer.files)];
        },
        handleFileSelect(event) {
            this.files = [...this.files, ...Array.from(event.target.files)];

        },
        removeFile(index) {
            this.files.splice(index, 1);
        },
        formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        },
        async uploadFiles() {
            if (this.files.length === 0) {
                return;
            }

            this.isUploading = true;
            const formData = new FormData();
            this.company_ids.forEach(id => {
                formData.append('companies[]', id);
            });
            this.files.forEach((file) => {
                formData.append('files[]', file);
            });

            try {
                const response = await axios.post('/playlist-gateways/import', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                this.alert = {
                    type: 'success',
                    message: response.data.message + '<br>'
                };
                response.data.files.forEach(file => {
                    this.alert.message += file.name + '<br>'
                });
                this.files = [];
                this.company_ids = [];
            } catch (error) {
                this.alert = {
                    type: 'error',
                    message: error
                };
                if (error.response && error.response.data && error.response.data.error) {
                    this.alert.message = error.response.data.error;
                }
                else if(error.response && error.response.data && error.response.data.errors) {
                    this.alert.message = Object.values(error.response.data.errors).flat().join('<br>');
                }
            } finally {
                this.isUploading = false;
            }
        },
        preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        highlight(e) {
            const dropArea = this.$refs.dropArea;
            console.log('type' + e.type);
            if (e.type === 'dragenter' || e.type === 'dragover') {
                dropArea.classList.add('highlight');
            } else {
                dropArea.classList.remove('highlight');
            }
        },
    },
};
</script>

<style scoped>
.drop-area {
    border: 2px dashed #ccc;
    padding: 20px;
    text-align: center;
    cursor: pointer;
}

.drop-area.highlight {
    border-color: var(--v-primary-base);
    background-color: var(--v-secondary-base);
    opacity: 0.7;
}
</style>
